export default __webpack_public_path__ + "static/media/wallet.2bdd1899.png";